import React from "react";
import { Grid, Box, Button } from "@mui/material";
import { toast } from "react-toastify";
import { productService } from "../../utils/services/productService";

const ProductActions = ({
  productDetails,
  setProductDetails,
  selectedClient,
  setSelectedClient,
  vendor,
  variants,
  imageUrl,
  clientId,
  navigate,
  selectedImages,
  selectedProduct,
  setSelectedProduct,
  setImageUrl,
  setVariants,
  initialData,
  setVendor,
  setFormErrors,
  formErrors,
}) => {
  const resetSelectedImage = () => {
    setImageUrl([]);
  };

  const validateForm = () => {
    let valid = true;
    if (!productDetails.name) {
      valid = false;
      setFormErrors((prev) => ({ ...prev, name: "Product name is required" }));
    }
    if (!productDetails.currency) {
      valid = false;
      setFormErrors((prev) => ({ ...prev, currency: "Currency is required" }));
    }
    if (!productDetails.status) {
      valid = false;
      setFormErrors((prev) => ({ ...prev, status: "Status is required" }));
    }

    const regex = /^[a-zA-Z0-9][a-zA-Z0-9_-]*$/;

    for (let index = 0; index < variants.length; index++) {
      const variant = variants[index];
      const trimmed = (variant.sku?.sku || variant.sku || "").trim();

      if (!variant.title || variant.title.trim() === "") {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_title"]: "Title is required",
          },
        }));
      }

      if (!variant.price || variant.price < 0) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_price"]: "Price must be a non-negative number",
          },
        }));
      }
      if (!trimmed) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: { ...prev.variants, [index + "_sku"]: "SKU is required" },
        }));
      }

      // if (!variant.country_of_origin) {
      //   setFormErrors((prev) => ({
      //     ...prev,
      //     variants: {
      //       ...prev.variants,
      //       [index + "_country_of_origin"]:
      //         "Country of origin must be a valid 2-letter country code.",
      //     },
      //   }));
      // }
      const { height, width, length, weight } = variant;

      if (height && (isNaN(height) || parseFloat(height) < 0)) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_height"]: "Height must be a non-negative number",
          },
        }));
      }
      if (width && (isNaN(width) || parseFloat(width) < 0)) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_width"]: "Width must be a non-negative number",
          },
        }));
      }
      if (length && (isNaN(length) || parseFloat(length) < 0)) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_length"]: "Length must be a non-negative number",
          },
        }));
      }
      if (weight && (isNaN(weight) || parseFloat(weight) < 0)) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_weight"]: "Weight must be a non-negative number",
          },
        }));
      }
      if (
        !variant.height_unit &&
        (variant.height || variant.width || variant.length)
      ) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_dimension_unit"]: "Dimension unit is required",
          },
        }));
      }
      if (!variant.weight_unit && variant.weight) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_weight_unit"]: "Weight unit is required",
          },
        }));
      }

      //add check for sku pattern as min 4 - 30 characters
      if (!regex.test(trimmed) || trimmed.length < 4 || trimmed.length > 30) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_sku"]:
              "Invalid SKU. Use 4–30 characters: A–Z, 0–9, - or _ (start with a letter).",
          },
        }));
      }
      //check if the sku is already used in other variants. if present show error
      const skuCount = variants.filter((v, i) => {
        const vSku = (v.sku?.sku || v.sku || "").trim();
        return vSku === trimmed && i !== index;
      }).length;

      if (skuCount > 0) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_sku"]: "SKU must be unique across variants.",
          },
        }));
      }
      const hsCodeLength = variant.hs_code?.toString()?.length;
      if (variant.hs_code && (hsCodeLength < 8 || hsCodeLength > 12)) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_hs_code"]:
              "HS Code length must be between 8 and 12 characters.",
          },
        }));
      }
      const htsCodeLength = variant.hts_code?.toString()?.length;
      if (variant.hts_code && (htsCodeLength < 8 || htsCodeLength > 12)) {
        valid = false;
        setFormErrors((prev) => ({
          ...prev,
          variants: {
            ...prev.variants,
            [index + "_hts_code"]:
              "HTS Code length must be between 8 and 12 characters.",
          },
        }));
      }
      if (variant.subSkus && variant.subSkus.length > 0) {
        variant.subSkus.forEach((subSku, subIndex) => {
          const subTrimmed = (subSku.sku?.sku || subSku.sku || "").trim();
          if (!subTrimmed) {
            valid = false;
            setFormErrors((prev) => ({
              ...prev,
              variants: {
                ...prev.variants,
                [`${index}_subSku_${subIndex}_sku`]: "SKU is required",
              },
            }));
          }

          //add check for sku pattern as min 4 - 30 characters
          if (
            !regex.test(subTrimmed) ||
            subTrimmed.length < 4 ||
            subTrimmed.length > 30
          ) {
            valid = false;
            setFormErrors((prev) => ({
              ...prev,
              variants: {
                ...prev.variants,
                [`${index}_subSku_${subIndex}_sku`]:
                  "Invalid SKU. Use 4–30 characters: A–Z, 0–9, - or _ (start with a letter).",
              },
            }));
          }

          //check if the sku is already used in other variants. if present show error
          const subSkuCount = variants.reduce((count, v, i) => {
            v.subSkus = v.subSkus || [];
            v.subSkus.forEach((s, si) => {
              const sSku = (s.sku?.sku || s.sku || "").trim();
              if (sSku === subTrimmed && !(i === index && si === subIndex)) {
                count++;
              }
            });
            return count;
          }, 0);

          if (subSkuCount > 0) {
            valid = false;
            setFormErrors((prev) => ({
              ...prev,
              variants: {
                ...prev.variants,
                [`${index}_subSku_${subIndex}_sku`]:
                  "SKU must be unique across variants.",
              },
            }));
          }
        });
        //check  subsku  price non negative
        variant.subSkus.forEach((subSku, subIndex) => {
          if (!subSku.price || subSku.price < 0) {
            valid = false;
            setFormErrors((prev) => ({
              ...prev,
              variants: {
                ...prev.variants,
                [`${index}_subSku_${subIndex}_price`]:
                  "Price must be a non-negative number",
              },
            }));
          }
        });
        //check  subsku title non empty
        variant.subSkus.forEach((subSku, subIndex) => {
          if (!subSku.title || subSku.title.trim() === "") {
            valid = false;
            setFormErrors((prev) => ({
              ...prev,
              variants: {
                ...prev.variants,
                [`${index}_subSku_${subIndex}_title`]: "Title is required",
              },
            }));
          }
        });
        if (variant.isBundle) {
          //check subsku product is selected
          variant.subSkus.forEach((subSku, subIndex) => {
            if (!subSku.product || !subSku.product._id) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_product`]:
                    "Product must be selected",
                },
              }));
            }
          });
          //check hs code length 8-12
          variant.subSkus.forEach((subSku, subIndex) => {
            const hsCodeLength = subSku.hs_code?.toString()?.length;
            if (!subSku.hs_code || hsCodeLength < 8 || hsCodeLength > 12) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_hs_code`]:
                    "HS Code length must be between 8 and 12 characters.",
                },
              }));
            }
          });
          //check hts code length 8-12
          variant.subSkus.forEach((subSku, subIndex) => {
            const htsCodeLength = subSku.hts_code?.toString()?.length;
            if (!subSku.hts_code || htsCodeLength < 8 || htsCodeLength > 12) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_hts_code`]:
                    "HTS Code length must be between 8 and 12 characters.",
                },
              }));
            }
          });
          //check country of origin 2 letter code
          variant.subSkus.forEach((subSku, subIndex) => {
            if (!subSku.country_of_origin) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_country_of_origin`]:
                    "Country of origin must be a valid 2-letter country code.",
                },
              }));
            }
          });
          //check subsku dimension and weight non negative
          variant.subSkus.forEach((subSku, subIndex) => {
            const { height, width, length, weight } = subSku;

            if (!height || isNaN(height) || parseFloat(height) < 0) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_height`]:
                    "Height must be a non-negative number",
                },
              }));
            }
            if (!width || isNaN(width) || parseFloat(width) < 0) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_width`]:
                    "Width must be a non-negative number",
                },
              }));
            }
            if (!length || isNaN(length) || parseFloat(length) < 0) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_length`]:
                    "Length must be a non-negative number",
                },
              }));
            }
            if (!weight || isNaN(weight) || parseFloat(weight) < 0) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_weight`]:
                    "Weight must be a non-negative number",
                },
              }));
            }
            if (
              (subSku.height || subSku.width || subSku.length) &&
              !subSku.height_unit
            ) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_dimension_unit`]:
                    "Dimension unit is required",
                },
              }));
            }
            if (subSku.weight && !subSku.weight_unit) {
              valid = false;
              setFormErrors((prev) => ({
                ...prev,
                variants: {
                  ...prev.variants,
                  [`${index}_subSku_${subIndex}_weight_unit`]:
                    "Weight unit is required",
                },
              }));
            }
          });
        }
      }
    }

    if (!selectedClient?._id && !clientId) {
      valid = false;
      setFormErrors((prev) => ({ ...prev, client_id: "Client is required" }));
    }
    if (!vendor?._id) {
      valid = false;
      setFormErrors((prev) => ({ ...prev, vendor: "Supplier is required" }));
    }

    return valid;
  };

  const flattenProductVariants = (variants) => {
    const flatVariants = [];
    for (const variant of variants || []) {
      const { subSkus, ...mainVariant } = variant;
      flatVariants.push(mainVariant);
      if (
        Array.isArray(subSkus) &&
        (mainVariant.isBundle || mainVariant.isMaster)
      ) {
        for (const subSku of subSkus) {
          flatVariants.push({
            sku: subSku.sku?.sku || subSku.sku || "",
            price: subSku.price,
            hs_code: subSku.hs_code,
            hts_code: subSku.hts_code,
            country_of_origin: subSku.country_of_origin,
            inventory: subSku.inventory,
            height: subSku.height,
            width: subSku.width,
            length: subSku.length,
            weight: subSku.weight,
            height_unit: subSku.height_unit,
            width_unit: subSku.width_unit,
            length_unit: subSku.length_unit,
            weight_unit: subSku.weight_unit,
            product: subSku.product?._id,
            parent: subSku.parent,
            uid: subSku.uid,
            child: subSku.child,
            title: subSku.title,
            option: subSku.option || [],
          });
        }
      }
    }
    return flatVariants;
  };

  const createProduct = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      // toast.warning("Please fill all mandatory fields.");
      return;
    }
    try {
      const client_id = clientId || selectedClient?._id;
      await productService.create({
        ...productDetails,
        client_id,
        variants: flattenProductVariants(variants),
        images: imageUrl,
        vendor: vendor._id,
        category_id:
          productDetails.category_id?._id || productDetails.category_id || null,
        category: productDetails.category_id?.name || "",
      });
      toast.success("Product Created successfully!");
      setImageUrl([]);
      setVariants([]);
      setProductDetails(initialData);
      setVendor(null);
      setSelectedClient({ name: "" });
      localStorage.setItem("path", `/product?child=true`);
      navigate("/product?child=true");
    } catch (error) {
      console.error("Create failed:", error);
    }
  };

  const handleEditProduct = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      // toast.warning("Please fill all mandatory fields.");
      return;
    }
    try {
      const client_id = clientId || selectedClient?._id;
      const imageField =
        selectedImages.length > 0
          ? selectedImages.map((image) => ({
              image: image.image,
              feature_image: image.feature_image,
              url: image.url,
            }))
          : selectedProduct.images;

      await productService.edit(
        {
          ...productDetails,
          images: imageField,
          variants: flattenProductVariants(variants),
          vendor: vendor?._id,
          client_id,
          category_id:
            productDetails.category_id?._id ||
            productDetails.category_id ||
            null,
          category: productDetails.category_id?.name || "",
        },
        selectedProduct._id,
      );

      toast.success("Product Updated successfully!");
      setImageUrl([]);
      setVariants([]);
      setProductDetails(initialData);
      setVendor(null);
      setSelectedClient({ name: "" });
      setSelectedProduct(null);
      localStorage.setItem("path", `/product?child=true`);
      navigate("/product?child=true");
    } catch (error) {
      console.error("Edit failed:", error);
      toast.error("Failed to edit product.");
    }
  };

  return (
    <Grid item xs={12}>
      <Box
        style={{
          padding: 5,
          display: "flex",
          justifyContent: "flex-end",
          marginRight: 15,
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            setSelectedClient({});
            resetSelectedImage();
            navigate("/product?child=true");
          }}
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          color={"primary"}
          onClick={(e) =>
            selectedProduct ? handleEditProduct(e) : createProduct(e)
          }
          style={{ textTransform: "none", marginLeft: 10 }}
          // disabled={!validateForm()}
        >
          {selectedProduct ? "Save" : "Add"}
        </Button>
      </Box>
    </Grid>
  );
};

export default ProductActions;
